import React, { useState, forwardRef, useImperativeHandle } from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { useSnackbar } from 'notistack';

import {
  capturaDigitalIniciar,
  capturaDigitalConfirmar,
} from '../../../services/biometria';
import {
  TIPO_DEDO_BIOMETRIA_ANELAR_DIREITO,
  TIPO_DEDO_BIOMETRIA_ANELAR_ESQUERDO,
  TIPO_DEDO_BIOMETRIA_INDICADOR_DIREITO,
  TIPO_DEDO_BIOMETRIA_INDICADOR_ESQUERDO,
  TIPO_DEDO_BIOMETRIA_MEDIO_DIREITO,
  TIPO_DEDO_BIOMETRIA_MEDIO_ESQUERDO,
  TIPO_DEDO_BIOMETRIA_MINIMO_DIREITO,
  TIPO_DEDO_BIOMETRIA_MINIMO_ESQUERDO,
  TIPO_DEDO_BIOMETRIA_POLEGAR_DIREITO,
  TIPO_DEDO_BIOMETRIA_POLEGAR_ESQUERDO,
} from '../../../utils';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    // color: theme.palette.grey[500],
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));
/*
const GenericoInput = forwardRef(({ formato, ...props }, ref) => (
  <TemplateNumberFormatInput {...props} formato={formato} ref={ref} />
)); */

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

function getLabelDedo(finger) {
  if (!finger) return '';
  switch (finger.id) {
    case TIPO_DEDO_BIOMETRIA_ANELAR_DIREITO:
      return 'Anelar Direito';
    case TIPO_DEDO_BIOMETRIA_ANELAR_ESQUERDO:
      return 'Anelar Esquerdo';
    case TIPO_DEDO_BIOMETRIA_INDICADOR_DIREITO:
      return 'Indicador Direito';
    case TIPO_DEDO_BIOMETRIA_INDICADOR_ESQUERDO:
      return 'Indicador Esquerdo';
    case TIPO_DEDO_BIOMETRIA_MEDIO_DIREITO:
      return 'Médio Direito';
    case TIPO_DEDO_BIOMETRIA_MEDIO_ESQUERDO:
      return 'Médio Esquerdo';
    case TIPO_DEDO_BIOMETRIA_MINIMO_DIREITO:
      return 'Mínimo Direito';
    case TIPO_DEDO_BIOMETRIA_MINIMO_ESQUERDO:
      return 'Mínimo Esquerdo';
    case TIPO_DEDO_BIOMETRIA_POLEGAR_DIREITO:
      return 'Polegar Direito';
    case TIPO_DEDO_BIOMETRIA_POLEGAR_ESQUERDO:
      return 'Polegar Esquerdo';
    default:
      return '';
  }
}

const DialogoCategoriaTransacao = forwardRef(
  ({ handleClose, handleSave }, ref) => {
    const [open, setOpen] = useState(false);
    const [etapa, setEtapa] = useState(1);
    const { enqueueSnackbar } = useSnackbar();
    const [finger, setFinger] = useState(null);

    const classes = useStyles({ cor: '#009FD4' });

    const handleCloseDialog = () => {
      setOpen(false);
      handleClose();
      setEtapa(1);
      setFinger(null);
    };

    const handleSalvarDialog = (template, finger) => {
      setOpen(false);
      handleSave(template, finger);
      setEtapa(1);
      setFinger(null);
    };

    async function reiniciar(finger) {
      try {
        setOpen(true);
        setEtapa(1);
        const response1 = await capturaDigitalIniciar();
        setEtapa(2);
        const response2 = await capturaDigitalConfirmar();
        setEtapa(3);
        handleSalvarDialog(response2.template, finger);
      } catch (error) {
        enqueueSnackbar('Erro ao capturar digital', { variant: 'error' });
        handleCloseDialog();
      }
    }

    useImperativeHandle(ref, () => ({
      handleOpen(finger, digital) {
        reiniciar(finger);
        setOpen(true);
        setFinger(finger);
      },
    }));

    return (
      <div>
        <Dialog
          open={open}
          aria-labelledby="form-dialog-title"
          classes={{ paper: classes.rootDialogo }}
          className={classes.rootDialogo}
          fullWidth
          maxWidth="sm"
          TransitionComponent={Transition}
          keepMounted
        >
          <DialogTitle
            id="form-dialog-title"
            onClose={handleCloseDialog}
            style={{ backgroundColor: '#009FD4', color: 'white' }}
          >
            {`Captura de Digital - ${getLabelDedo(finger)}`}
          </DialogTitle>
          <DialogContent
            style={{
              padding: '10px 36px 20px',
              margin: '0',
            }}
          >
            <div>
              <Box display="flex" flexDirection="column" alignItems="center">
                <Typography variant="h6">
                  {etapa === 1
                    ? 'Coloque o dedo'
                    : 'Coloque o mesmo dedo novamente'}
                </Typography>

                <Box display="flex" mt={3} gap={4}>
                  {/* Captura 1 */}
                  <Box
                    width={60}
                    height={60}
                    borderRadius="50%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    style={{
                      backgroundColor: etapa > 1 ? '#4caf50' : '#e0e0e0',
                      color: etapa > 1 ? 'white' : '#999',
                    }}
                  >
                    1
                  </Box>

                  {/* Captura 2 */}
                  <Box
                    width={60}
                    height={60}
                    borderRadius="50%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    style={{
                      backgroundColor: etapa > 2 ? '#4caf50' : '#e0e0e0',
                      color: etapa > 2 ? 'white' : '#999',
                    }}
                  >
                    2
                  </Box>
                </Box>
              </Box>
            </div>
          </DialogContent>
          <DialogActions
            style={{
              padding: '0px 36px 20px',
              margin: '0',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Button
              onClick={handleCloseDialog}
              classes={{
                root: classes.btnAtions,
                disabled: classes.btnAtionsDisabled,
              }}
              variant="contained"
              color="primary"
            >
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  },
);

export default DialogoCategoriaTransacao;
